{{#unless isVirtual}}
    <li data-id="{{item.id}}" class="list-item btn">
        <h3>{{item.getLabel()}}</h3>
        <p>{{item.getAdditionalLabels()}}</p>
    </li>
{{/unless}}
